export const mockApiResponse = (chain: string, address: string, type: number) => {
  if (!chain) {
    return {
      api_version: '3.0',
      data: {},
      errors: {
        code: 'ZENCS-PARAMGET-AA5',
        message: 'chain not provided',
      },
    }
  }

  if (!address) {
    return {
      api_version: '3.0',
      data: {},
      errors: {
        code: 'ZENCS-PARAMGET-AA4',
        message: 'address not provided',
      },
    }
  }

  if (chain === 'ETH' && address === '0x1da5821544e25c636c1417ba96ade4cf6d2f9b5a') {
    if (type === 0) {
      return {
        api_version: '3.0',
        data: {
          screening_report: {
            status: 'filed',
            details: [
              {
                category: 'sanctioned entity',
                name: 'SANCTIONED ENTITY: OFAC SDN Secondeye Solution 2021-04-15 1da5821544e25c636c1417ba96ade4cf6d2f9b5a',
              },
              {
                category: 'sanctions',
                name: 'SANCTIONS: OFAC SDN Secondeye Solution 2021-04-15 1da5821544e25c636c1417ba96ade4cf6d2f9b5a',
              },
            ],
          },
        },
      }
    }
    if (type === 1) {
      return {
        api_version: '3.0',
        data: {
          screening_report: {
            blockchain: 'ETH',
            address: '0x1da5821544e25c636c1417ba96ade4cf6d2f9b5a',
            sanctioned_or_investigated: true,
            details: [
              {
                report_data: [
                  {
                    description:
                      "TheQddress listed on the US Treasury Department's Office of Foreign Assets Control sanction list.",
                  },
                ],
                owner_info: [
                  {
                    owner_info: [
                      {
                        name: 'Bittrex.com',
                        url: 'https://www.Bittrex.com',
                        legal_name: 'Bittrex Global GmbH',
                      },
                    ],
                  },
                ],
              },
            ],
          },
        },
      }
    }
  }

  if (chain === 'ETH' && address === '0x3902768B8F7128788D2188f770255A4fc895E793') {
    if (type === 0) {
      return {
        api_version: '3.0',
        data: {
          screening_report: {
            status: 'clean',
            details: [],
          },
        },
      }
    }
    if (type === 1) {
      return {
        api_version: '3.0',
        data: {
          screening_report: {
            sanctioned_or_investigated: true,
            details: [
              {
                blockchain: 'ETH',
                address: '0x3902768B8F7128788D2188f770255A4fc895E793',
                report_data: [
                  {
                    description:
                      'Address with significant part of transactions in close proximity to illicit activities',
                  },
                ],
                owner_info: null,
              },
            ],
          },
        },
      }
    }
  }

  if (chain === 'ETH' && address === '0x3902768B8F7128788D2188f770255A4fc895E792') {
    if (type === 0) {
      return {
        api_version: '3.0',
        data: {
          screening_report: {
            status: 'clean',
            details: [],
          },
        },
      }
    }
    if (type === 1) {
      return {
        api_version: '3.0',
        data: {
          screening_report: {
            sanctioned_or_investigated: false,
            details: [
              {
                blockchain: 'ETH',
                address: '0x3902768B8F7128788D2188f770255A4fc895E792',
                report_data: [
                  {
                    description: 'No risk indicator has been triggered for this address',
                  },
                ],
                owner_info: null,
              },
            ],
          },
        },
      }
    }
  }

  return {
    status: 'success',
    chain,
    address,
    message: `Mock response for chain ${chain} and wallet address ${address}`,
  }
}

export default mockApiResponse
